var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('el-row',{staticClass:"declaration"},[_c('el-col',{attrs:{"sm":12,"xs":24}},[_c('p',{staticClass:"copyright"},[_vm._v("Copyright © 2021-2022 Alphatenbyte. All Rights Reserved")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }